import BookAppointment from '@/components/modules/modals/BookAppointment/BookAppointment';
import { BookAppointmentProvider } from '@/components/modules/modals/BookAppointment/BookAppointment.hooks';
import { APP_ROUTES } from '@/constants/pages';
import { trackPage } from '@/helpers';
import { trackMpEvent } from '@/helpers/analyticsTS';
import { Tracking } from '@/types/analytics';
import { useEffect } from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { DealsSearchProvider, DealsSearchType } from '../hooks/useDealsSearch';
import withDealsFeatureFlag from '../withDealsFeatureFlag';
import DealsSearchPreview from './DealsSearchPreview';
import DealsSearchResults from './DealsSearchResults';

export const DEALS_GRADIENT_STOP = { '--gradient-deals-stop': '520px' } as React.CSSProperties;

export function useDealsPageType(): DealsSearchType {
  const isOnDealsSerp = useRouteMatch(APP_ROUTES.DEALS_SERP)?.isExact;
  const isOnDealsSerpNoIndex = useRouteMatch(APP_ROUTES.DEALS_SERP_NO_INDEX)?.isExact;
  const isOnSistaminutenSerp = useRouteMatch(APP_ROUTES.SISTA_MINUTEN_SERP)?.isExact;
  const isOnSistaminutenSerpNoIndex = useRouteMatch(APP_ROUTES.SISTA_MINUTEN_SERP_NO_INDEX)?.isExact;
  const isOnBrandDealsSerp = useRouteMatch(APP_ROUTES.BRAND_DEALS_SERP)?.isExact;
  const isOnBrandDealsSerpNoIndex = useRouteMatch(APP_ROUTES.BRAND_DEALS_SERP_NO_INDEX)?.isExact;

  if (isOnDealsSerp || isOnDealsSerpNoIndex) {
    return 'deals';
  }

  if (isOnSistaminutenSerp || isOnSistaminutenSerpNoIndex) {
    return 'deals_sistaminuten';
  }

  if (isOnBrandDealsSerp || isOnBrandDealsSerpNoIndex) {
    return 'brand_deals';
  }

  return 'deals_preview';
}

const DealsSearchPage = () => {
  const type = useDealsPageType();
  const isResultsPage = type === 'deals' || type === 'deals_sistaminuten' || type === 'brand_deals';

  const routePaths = isResultsPage
    ? [
        APP_ROUTES.SISTA_MINUTEN_SERP_NO_INDEX,
        APP_ROUTES.DEALS_SERP_NO_INDEX,
        APP_ROUTES.BRAND_DEALS_SERP_NO_INDEX,
        APP_ROUTES.DEALS_SERP,
        APP_ROUTES.SISTA_MINUTEN_SERP,
        APP_ROUTES.BRAND_DEALS_SERP,
      ]
    : [APP_ROUTES.DEALS_SERP_PREVIEW_NO_INDEX, APP_ROUTES.DEALS_SERP_PREVIEW];

  useEffect(() => {
    const screen_name: Tracking.ScreenName = 'deals_search_results';
    trackMpEvent(
      {
        name: 'screen_shown',
        properties: { screen_name },
      },
      { sendToCio: false },
    );

    trackPage();
  }, []);

  return (
    <Route path={routePaths}>
      <DealsSearchProvider type={type}>
        <BookAppointmentProvider>
          {isResultsPage ? <DealsSearchResults /> : <DealsSearchPreview />}
          <BookAppointment />
        </BookAppointmentProvider>
      </DealsSearchProvider>
    </Route>
  );
};

export default withDealsFeatureFlag(DealsSearchPage);
